import { learningApi } from 'services/api'

export const FAVORITE_COURSE = async (courseId: string, type: string, subscriptionId: string) => {
  try {
    const token = localStorage.getItem('token')

    await learningApi.post(
      `/course/favorite-courses`,
      {
        courseId,
        type,
        subscriptionId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
  } catch (err) {
    console.log(err)
    throw err
  }
}
export const GET_SUBSCRIPTION_COURSES = async (
  page: number,
  filter: { name: string; career: string; state: string },
  subscriptionId: string
) => {
  try {
    const token = localStorage.getItem('token')

    const response = await learningApi.post(
      `/course/subscriptions`,
      {
        page,
        limit: 12,
        filter,
        subscription: subscriptionId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )

    return response.data
  } catch (err) {
    console.log(err)
    throw err
  }
}
